import * as e from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/SmileySticker.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(i, { ref: t, ...r, weights: m }));
o.displayName = "SmileyStickerIcon";
const s = o;
export {
  s as SmileySticker,
  o as SmileyStickerIcon
};
